<template>
  <div class="currency-input clearfix">
    <div class="form-group row" :class="{ 'has-feedback' : isDirty }">
      <label :for="options.name" :class="options.fullWidth ? 'col-sm-12' : 'col-sm-4 col-form-label'">
        {{ options.label }}
        <span v-if="options.required" class="required">*</span>
      </label>
      <div :class="options.fullWidth ? 'col-sm-12' : 'col-sm-8'">
        <div class="input-group">
          <input class="form-control" type="text"
            :id="options.name"
            :value="value"
            :name="options.name"
            @input="validate($event.target.value)"/>
          <div class="input-group-append">
            <div class="input-group-text" v-if="isRegex">
              {{ value | to_dollar_amount }}
            </div>
            <div class="input-group-text" v-else>
              Invalid Dollar Amount
            </div>
          </div>
        </div>
        <span :class="validationClass" v-show="validationMessage">
          {{ validationMessage }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import {
  validationClass,
  validationIcon,
  validationMessage
} from '@/util/helpers'

export default {
  name: 'CurrencyInput',
  props: {
    value: {
      type: [String, Number]
    },
    options: {
      type: Object,
      default () {
        return {
          name: '',
          label: '',
          required: false
        }
      }
    }
  },
  data () {
    return {
      isValid: false,
      isDirty: false,
      isLength: false,
      isRegex: false,
      regex: /^[0-9]*(\.[0-9]{1,2}){0,1}$/,
      maxValue: false,
      minValue: false
    }
  },
  computed: {
    validationClass,
    validationIcon,
    validationMessage,
    invalidMessage () {
      if (this.maxValue && this.value > this.maxValue && this.isRegex) {
        return 'Amount cannot be more than $' + this.maxValue
      } else if (this.minValue || this.options.minValue === 0 && this.value <= this.minValue && this.isRegex) {
        return 'Amount must be more than $' + this.minValue
      } else {
        return 'The amount entered is not a valid dollar amount'
      }
    }
  },
  mounted () {
    if (this.options.maxValue) {
      this.maxValue = parseFloat(this.options.maxValue)
    }
    if (this.options.minValue || this.options.minValue === 0) {
      this.minValue = parseFloat(this.options.minValue)
    }
    this.validate()
  },
  methods: {
    validate (val = this.value) {
      if (val === null) {
        val = '0'
      }
      this.$emit('input', val)
      if (val) {
        this.isDirty = true
        this.isLength = this.isValid = val.length !== 0
        if (this.isValid) {
          this.isRegex = this.isValid = new RegExp(this.regex, 'gi').test(val)
        }
        if (this.maxValue && this.isValid) {
          this.isValid = parseFloat(val) <= this.maxValue
        }
        if (this.minValue || this.options.minValue === 0 && this.isValid) {
          this.isValid = this.isValid && parseFloat(val) > this.minValue
        }
      } else if (this.options.required) {
        this.isDirty = true
        this.isValid = false
      } else {
        this.isValid = true
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/inputs/CurrencyInput.vue